export enum ConfirmationEnum {
  deletingBudget = "deletingBudget",
  usingWeakPassword = "usingWeakPassword",
  deletingAccount = "deletingAccount",
  deletingEarnVersion = "deletingEarnVersion",
  deletingAccountWithGeneratedMessage = "deletingAccountWithGeneratedMessage",
  deletingTransaction = "deletingTransaction",
  unlinkingTransaction = "unlinkingTransaction",
  usingDefaultInstitution = "usingDefaultInstitution",
  givingFirstConsent = "givingFirstConsent",
  havingNoChanges = "havingNoChanges",
  updatingBalance = "updatingBalance",
  deletingEstimate = "deletingEstimate",
  deletingCategory = "deletingCategory",
  renamingCategory = "renamingCategory",
  deletingClassification = "deletingClassification",
  deletingInstitution = "deletingInstitution",
  deletingSymbol = "deletingSymbol",
  askingForEarlyAccess = "askingForEarlyAccess",
  askingForReConsentOfExpired = "askingForReConsentOfExpired",
  askingForReConsentOfRevoked = "askingForReConsentOfRevoked",
  removingBasiqDataOfRevokedConsent = "removingBasiqDataOfRevokedConsent",
  removingBasiqDataOfExpiredConsent = "removingBasiqDataOfExpiredConsent",
  importError = "importError",
  logOutConfirmation = "logOutConfirmation",
  turnOffBiometrics = "turnOffBiometrics",
  turnOffBiometricsOnOtherDevice = "turnOffBiometricsOnOtherDevice",
  switchToFreePlan = "switchToFreePlan",
  updateBalanceAutomatically = "updateBalanceAutomatically",
  deletingPaymentMethod = "deletingPaymentMethod",
  autoCreatingBudget = "autoCreatingBudget",
  removingPasswordHint = "removingPasswordHint",

  pluginGatheringData = "pluginGatheringData",
  pluginReadyToImport = "pluginReadyToImport",
  pluginSyncCompleted = "pluginSyncCompleted",
  fiskilDataReadyPullNow = "fiskilDataReadyPullNow",
  confirmingBundleSwitch = "confirmingBundleSwitch",
  leavingCreateAccountFlow = "leavingCreateAccountFlow",
  deletingVaultDuplicates = "deletingVaultDuplicates",
  bulkDeleteUnusedVaultSources = "bulkDeleteUnusedVaultSources",
  removeAllVaultDuplicatesForType = "removeAllVaultDuplicatesForType",
  processTakingTooLongRefresh = "processTakingTooLongRefresh",
  deletingGroceryList = "deletingGroceryList",
  discardingKeychainChanges = "discardingKeychainChanges",
  discardingUnsavedChanges = "discardingUnsavedChanges",
  archivingUntickedGroceryList = "archivingUntickedGroceryList",
}
